import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, redirect } from "react-router-dom";
import {updateUserInfo, userInfo, updateToken} from './../../app/api';
import { UserContext } from "../../providers/UserProvider";
import OrderInfo from "./order";
import { QRCode } from "react-qrcode-logo";
import { Disclosure } from "@headlessui/react";

export const UserProfile = () => {
  const nav = useNavigate();
  const {userBio} = useContext(UserContext);
  useEffect(() => {
    if(userBio) {
      nav(`/profile/${userBio.id}`);
    }
  }, [userBio]);

  return (<></>);
}

export const Profile = () => {
  const {role} = useContext(UserContext);
  const {id} = useParams();

  const [profileBio, setProfileBio] = useState<any | undefined>(undefined);
  const [orders, setOrders] = useState<any[]>([]);

  const [profileUpdateResponse, setProfileUpdateResponse] = useState<string | undefined>(undefined);
  const [profileUpdateError, setProfileUpdateError] = useState<string | undefined>(undefined);
  const [profileEdit, setProfileEdit] = useState(false);
  const [editImage, setEditImage] = useState<any | undefined>(undefined);
  const [profileEditLoading, setProfileEditLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchProfileBio = useCallback(async () => {
    if(id) {
      setLoading(true);
      try {
        updateToken();
        const resp = await userInfo(id);
        setProfileBio(resp.data.user);
        setOrders(resp.data.order);
      } catch(err) {
        console.log(err);
      }
      setLoading(false);
    }
  }, [id]);

  const handleProfileUpdate = useCallback(async () => {
    setProfileEditLoading(true);
    try {
      const formData = new FormData();

      formData.set('address', profileBio.address);
      formData.set('parentPhone', profileBio.parentPhone);
      formData.set('school', profileBio.school);
      formData.set('grade', profileBio.grade);
      if(editImage) {
        formData.set('image', editImage);
      }

      const resp = await updateUserInfo(id, formData);
      setProfileUpdateError(undefined);
      setProfileUpdateResponse('Амжилттай заслаа.');
      fetchProfileBio();
      setProfileEdit(false);
    } catch(err: any) {
      const resp = err.response;
      setProfileUpdateResponse(undefined);
      setProfileUpdateError(resp.data.error);
    }
    setProfileEditLoading(false);
  }, [id, profileBio]);

  const profileQR = useMemo(() => {
    if(id) {
      return (
        <div>
          <QRCode
            value={`https://nairamdal.mn/profile/${id}`}
            size={220}
            ecLevel="H"
            logoImage="/qr_logo.png"
            logoPaddingStyle="circle"
            logoPadding={10}
            removeQrCodeBehindLogo
            logoWidth={80}
          />
        </div>
      )
    }
    return <></>
  }, [id]);

  useEffect(() => {
    try {
      fetchProfileBio();
    } catch(err) {
      console.log(err);
    }
  }, [id]);

  return (
    <div className="mx-auto max-w-7xl p-10 pt-[140px] flex flex-col justify-center ">
      {loading &&
        <div className="w-full h-full fixed top-0 left-0 bg-white opacity-75 z-50">
          <div className="flex justify-center items-center mt-[50vh]">
            <div role="status" className="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
              <svg aria-hidden="true" className="w-24 h-24 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg>
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      }
      <h1 className="text-3xl text-[#001447] sm:text-3xl italic mb-5 font-bold">
        Хэрэглэгчийн булан
      </h1>
      { orders.map((order) => 
        <Disclosure defaultOpen>
          {({open}) => (
            <>
              <Disclosure.Button className="bg-[#F8F8FF] border-[1px] border-[#cecece] rounded-lg p-4 mb-6">
                <div className="flex w-full justify-between rounded-lg">
                  <p className="text-[#003463] text-md font-bold">{order.eelj?.title}</p>
                  <span className="ml-6 flex items-center">
                    {/* <svg className="block h-6 w-6 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                      {open ?
                        <path d="M19.5 12h-15"></path>
                        :
                        <path d="M12 4.5v15m7.5-7.5h-15" />
                      }
                    </svg> */}
                    <div className="w-[100px] text-center mt-2 rounded-full  px-3.5 py-2.5 text-sm font-semibold text-[white] cursor-pointer" style={{ background: "rgb(7, 178, 236)" }}>
                      {open ?
                        <p>Хаах</p>
                        :
                        <p>Нээх</p>
                      }
                    </div>

                  </span>
                </div>
              </Disclosure.Button>
              <Disclosure.Panel>
                <OrderInfo key={order.id} {...order} userRole={role}/>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure> 
      )}
      { profileBio && 
        <div className="mt-6 lg:grid lg:grid-cols-10 gap-10">
          <form className="col-span-10">
            <div className="grid p-4 lg:grid-flow-col gap-4">
              <div className="lg:col-span-2 md:col-span-1">
                <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
                  <div
                    style={{
                      backgroundImage: `url(${profileBio.image ?? ''})`
                    }}
                    className="relative bg-cover bg-center bg-no-repeat mb-5 flex w-full min-[495px]:w-[200px] h-[200px] bg-[#F8F8FF] rounded-lg border-[1px] border-dashed border-[#384EB730] justify-center items-center cursor-pointer hover:border-[#384EB7] transition ease-in-out delay-100"
                  />
                  <div className="bg-contain bg-center bg-no-repeat mb-5 w-full min-[495px]:w-[200px] h-[200px]">
                    {profileQR}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex mb-1">
              <h2 className="text-xl text-[#001447] italic font-bold">
                Хүүхдийн мэдээлэл
              </h2>
              {role === 'user' &&
                <span
                  style={{ textDecoration: "underline" }}
                  className="text-[#09B2EC] ml-2 cursor-pointer pt-[2px]"
                >
                  <button
                    style={{ textDecoration: "underline" }}
                    className="text-[#09B2EC] ml-2 cursor-pointer pt-[2px]"
                    onClick={(e) => {
                      e.preventDefault();
                      setProfileEdit(!profileEdit);
                      // handleProfileUpdate();
                    }}
                  >
                    Засах
                  </button>
                </span>
              }
            </div>

            {
              profileEdit &&
              <div>
                Шинэ зураг оруулах
                  <div className="flex flex-col items-center justify-center w-full mt-5">
                  <label
                    htmlFor="dropzone-file"
                    className="flex flex-col items-center justify-center w-full h-64 border-2 border-[#384EB7]/30 border-dashed rounded-lg cursor-pointer bg-[#F8F8F8]"
                  >
                    {!editImage ? (
                      <div className="flex flex-col items-center justify-center pt-5 pb-6">
                        <svg
                          className="w-10 h-10 mb-3 text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                          ></path>
                        </svg>
                        <p className="mb-2 text-sm text-[#0F0F0F]">
                          Drag & drop files or{" "}
                          <span className="font-semibold text-[#483EA8] underline">
                            Browse
                          </span>
                        </p>
                        <p className="text-xs text-[#676767]">
                          Supported formates: PNG, JPG (MAX. 800x400px)
                        </p>
                      </div>
                    ) : (
                      <img src={URL.createObjectURL(editImage)} width={200} height={200} alt="image"></img>
                    )}
                    <input
                      id="dropzone-file"
                      type="file"
                      className="hidden"
                      onChange={(e) => {
                        if(e.target.files) {
                          setEditImage(e.target.files[0]);
                        }
                      }}
                    />
                  </label>
                </div>
              </div>
            }

            <div className="grid pt-4 lg:grid-flow-col gap-4">
              <div className="lg:col-span-2">
                <div className="grid grid-cols-2 gap-4">
                  <label className="col-span-2 min-[495px]:col-span-1 mb-4">
                    <span className="text-gray-700">Овог</span>
                    <input
                      disabled
                      className="mt-1 block text-[#001447] w-full rounded-2xl border-[#001447]/20 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                      placeholder="Хүүхдийн овог"
                      type="text"
                      defaultValue="Lastname"
                      name="last_name"
                      value={profileBio.lastName}
                    />
                  </label>
                  <label className="col-span-2 min-[495px]:col-span-1 mb-4">
                    <span className="text-gray-700">Нэр</span>
                    <input
                      disabled
                      className="mt-1 block text-[#001447] w-full rounded-2xl border-[#001447]/20 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                      placeholder="Хүүхдийн нэр"
                      type="text"
                      defaultValue="FIrstname"
                      name="first_name"
                      value={profileBio.firstName}
                    />
                  </label>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <label className="col-span-2 min-[495px]:col-span-1 mb-4">
                    <span className="text-gray-700">Регистрийн дугаар</span>
                    <input
                      disabled
                      className="mt-1 block text-[#001447] w-full rounded-2xl border-[#001447]/20 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                      placeholder="Регистрийн дугаар"
                      type="text"
                      defaultValue="AA12345678"
                      name="registerNumber"
                      value={profileBio.registerNumber}
                    />
                  </label>
                  <label className="col-span-2 min-[495px]:col-span-1 mb-4">
                    <span className="text-gray-700">Төрсөн он, сар, өдөр</span>
                    <input
                      disabled
                      className="mt-1 block text-[#001447] w-full rounded-2xl border-[#001447]/20 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                      placeholder="Төрсөн он, сар, өдөр"
                      type="text"
                      defaultValue="2010-01-01"
                      name="birthDate"
                      value={profileBio.birthDate ? new Date(profileBio.birthDate).toISOString().split('T')[0]: ''}
                    />
                  </label>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <label className="col-span-2 min-[495px]:col-span-1 mb-4">
                    <span className="text-gray-700">Хэрэглэгчийн нэвтрэх утасны дугаар</span>
                    <input
                      disabled
                      className="mt-1 block w-full rounded-2xl border-[#001447]/20 text-[#001447] disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                      placeholder="Утасны дугаар"
                      maxLength={8}
                      minLength={8}
                      type="tel"
                      defaultValue={99012345}
                      name="phone"
                      value={profileBio.phone}
                    />
                  </label>
                  <label className="col-span-2 min-[495px]:col-span-1 mb-4">
                    <span className="text-gray-700">Имэйл</span>
                    <input
                      disabled
                      className="mt-1 block text-[#001447] w-full rounded-2xl border-[#001447]/20 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                      placeholder="Имэйл"
                      type="text"
                      defaultValue="email@example.com"
                      name="email"
                      value={profileBio.email}
                    />
                  </label>
                </div>
                <label className="block mt-4 pb-4">
                  <span className="text-gray-700">Хүйс</span>
                  <input
                    disabled
                    className="mt-1 block w-full rounded-2xl border-[#001447]/20 text-[#001447] disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                    placeholder="Хүйс"
                    type="text"
                    defaultValue="эрэгтэй"
                    name="gender"
                    value={profileBio.gender}
                  />
                </label>
                <label className="block mt-4 pb-4">
                  <span className="text-gray-700">Гэрийн хаяг</span>
                  <input
                    disabled={!profileEdit || role !== 'user'}
                    className="mt-1 block w-full rounded-2xl border-[#001447]/20 text-[#001447] disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                    type="text"
                    name="address"
                    value={profileBio.address}
                    onChange={(e) => {
                      setProfileBio({
                        ...profileBio,
                        address: e.target.value
                      });
                    }}
                  />
                </label>
                <div className="grid grid-cols-2 gap-4">
                  <label className="col-span-2 md:col-span-1 mb-4">
                    <span className="text-gray-700">Сургууль</span>
                    <input
                      disabled={!profileEdit || role !== 'user'}
                      className="mt-1 block text-[#001447] w-full rounded-2xl border-[#001447]/20 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                      type="text"
                      name="school"
                      value={profileBio.school}
                      onChange={(e) => {
                        setProfileBio({
                          ...profileBio,
                          school: e.target.value
                        });
                      }}
                    />
                  </label>
                  <label className="col-span-2 md:col-span-1 mb-4">
                    <span className="text-gray-700">Анги</span>
                    <input
                      disabled={!profileEdit || role !== 'user'}
                      className="mt-1 block text-[#001447] w-full rounded-2xl border-[#001447]/20 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                      placeholder="Анги"
                      type="text"
                      name="grade"
                      value={profileBio.grade}
                      onChange={(e) => {
                        setProfileBio({
                          ...profileBio,
                          grade: e.target.value
                        });
                      }}
                    />
                  </label>
                </div>
              </div>
            </div>
            <label className="block mt-4 pb-4">
              <span className="text-gray-700">Эцэг эхийн утасны дугаар</span>
              <input
                disabled={!profileEdit || role !== 'user'}
                className="mt-1 block w-full rounded-2xl border-[#001447]/20 text-[#001447] disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none"
                type="text"
                name="parentPhone"
                value={profileBio.parentPhone}
                onChange={(e) => {
                  setProfileBio({
                    ...profileBio,
                    parentPhone: e.target.value
                  });
                }}
              />
            </label>
            { profileEdit &&
              <>
                {profileEditLoading ?
                  <div className="w-[200px] px-3.5 py-2.5 rounded-full text-center text-[black] cursor-pointer bg-gray-200">
                    Илгээж байна
                  </div>
                  :
                  <div className="w-[200px] px-3.5 py-2.5 rounded-full text-center text-[white] cursor-pointer" style={{backgroundColor: "rgb(7, 178, 236)"}}
                    onClick={(e) => {
                      e.preventDefault();
                      handleProfileUpdate();
                    }}
                  >
                      <p className="w-full">
                        Илгээх
                      </p>
                  </div>
                  }
              </>
            }
            <div>
              {profileUpdateResponse &&
                <div className="text-green-300">{profileUpdateResponse}</div>
              }
              {profileUpdateError && 
                <div className="text-red-300">{profileUpdateError}</div>
              }
            </div>
          </form>
        </div>
      }
    </div>
  )
}

export default Profile;